import List from './List';
import reducer from './reducer';

const BookkeeperOrdersNew = {
  List,
  reducer
};

export default BookkeeperOrdersNew;
